import { useQuery } from "@tanstack/react-query";
import { queryVenueByID } from "supabase/venues";

type UseQueryVenueParams = {
  uid: string;
};

export const useQueryVenue = (params: UseQueryVenueParams) => {
  const { uid } = params;

  const {
    isLoading,
    isError,
    error,
    data: venue,
  } = useQuery({
    queryKey: ["venue", uid],
    queryFn: () => {
      return queryVenueByID({ uid });
    },
  });

  return { isLoading, isError, error, venue };
};
